import React from 'react';
import AllRoute from '../router'
import ScrollToHashElement from "../ScrollToHashElement"; // <--- ADD THIS
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const App = () => {
  return (
    <div className="App" id='scrool'>
      <ScrollToHashElement />
      <AllRoute />
      <ToastContainer />
    </div>
  );
}

export default App;